import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Star } from 'lucide-react';
import type { TaskFeedback } from '@/lib/types';

interface FeedbackListProps {
  feedback: TaskFeedback[];
}

export function FeedbackList({ feedback }: FeedbackListProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Feedback</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {feedback.map((item) => (
            <div
              key={item.id}
              className="p-4 rounded-lg border space-y-2"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, index) => (
                    <Star
                      key={index}
                      className={`h-4 w-4 ${
                        index < item.rating
                          ? 'fill-primary text-primary'
                          : 'fill-muted text-muted-foreground'
                      }`}
                    />
                  ))}
                </div>
                <span className="text-sm text-muted-foreground">
                  {new Date(item.createdAt).toLocaleDateString()}
                </span>
              </div>
              
              <p className="text-sm">{item.comment}</p>

              {item.images && item.images.length > 0 && (
                <div className="grid grid-cols-3 gap-2 pt-2">
                  {item.images.map((image) => (
                    <div
                      key={image.id}
                      className="relative aspect-square rounded-md overflow-hidden"
                    >
                      <img
                        src={image.url}
                        alt={image.caption || 'Feedback image'}
                        className="object-cover w-full h-full"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}